import React, { useState } from 'react'
import { useUserSession } from '@utils/useUserSession'
import CartItemConfigurationPopover from '@src/components/CartItemConfigurationPopover'
import { Link } from '@src/components/Link'
import { productDetailRoute, staticContent } from '@src/routes'
import { CartItemType, EmproveItemType } from '@src/types/graphql-types'
import { OrderItemFragment } from '@src/queries/OrderDetailsQuery.generated'
import LinkStyleButton, {
  LinkStyleButtonSizes,
} from '@src/components/LinkStyleButton/LinkStyleButton'
import { Typography } from '@material-ui/core'
import { OrderType } from '@src/routes/OrderCenter/OrderDetail/orderDetailUtils'

interface OrderItemNumberProps {
  item: OrderItemFragment
  className?: string
  orderType?: string | null
}

export const OrderItemNumber: React.FC<OrderItemNumberProps> = ({
  item,
  className,
  orderType,
}) => {
  const [confPopoverOpen, setConfPopoverOpen] = useState(false)
  const {
    userSession: { language, country },
  } = useUserSession()

  const emproveIteType =
    item.type === CartItemType.Emprove &&
    item?.emproveDossierInfo?.dossierSubType
  const emproveItemNo =
    item.type === CartItemType.Emprove &&
    item?.emproveDossierInfo?.dossierMaterialNumber

  return (
    <div className={className} data-testid="order-item-number">
      {item.type === CartItemType.Configurator ? (
        <CartItemConfigurationPopover
          id={
            confPopoverOpen ? `${item.materialNumber}-configuration` : undefined
          }
          open={confPopoverOpen}
          setOpen={(open: boolean) => setConfPopoverOpen(open)}
          materialNumber={item.materialNumber}
          configuration={item.configuration}
        >
          <LinkStyleButton
            size={LinkStyleButtonSizes.Inherit}
            onClick={() => setConfPopoverOpen(!confPopoverOpen)}
            aria-describedby={
              confPopoverOpen
                ? `${item.materialNumber}-configuration`
                : undefined
            }
          >
            {item.materialNumber}
          </LinkStyleButton>
        </CartItemConfigurationPopover>
      ) : item.type === CartItemType.Emprove ? (
        <Link
          {...staticContent.index({
            path: '/services/product-services/emprove-program',
            language,
            country,
          })}
        >
          {EmproveItemType.Single === emproveIteType
            ? `${item.material.number}-${emproveItemNo}`
            : `${item.material.number}-Subscription`}
        </Link>
      ) : orderType === OrderType.Emerald ? (
        <Link
          {...productDetailRoute.index(
            item.material.brand.key,
            item.material.product,
            item.type === CartItemType.ThirdPartyProvider
              ? { context: 'bbe' }
              : {}
          )}
        >
          {item.materialNumber}
        </Link>
      ) : item.material.name &&
        item.material.brand.key &&
        item.material.productKey ? (
        <Link
          {...productDetailRoute.index(
            item.material.brand.key,
            item.material.product,
            item.type === CartItemType.ThirdPartyProvider
              ? { context: 'bbe' }
              : {}
          )}
        >
          {item.materialNumber}
        </Link>
      ) : (
        <Typography variant="subtitle2">{item.materialNumber}</Typography>
      )}
    </div>
  )
}
